import { render, staticRenderFns } from "./formDetails.vue?vue&type=template&id=5c663388&scoped=true"
import script from "./formDetails.vue?vue&type=script&lang=js"
export * from "./formDetails.vue?vue&type=script&lang=js"
import style0 from "./formDetails.vue?vue&type=style&index=0&id=5c663388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c663388",
  null
  
)

export default component.exports